import { questionsSlice } from './slice';

export * from './questions';
export * from './state';
export * from './async';
export { getQuestionInterchange } from './question-interchange-types';

const Actions = questionsSlice.actions;
const Reducer = questionsSlice.reducer;

export { Reducer, Actions };
